var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66261 0.5C3.70681 0.5 0.5 3.70723 0.5 7.66355C0.5 11.6199 3.70681 14.8271 7.66261 14.8271C9.368 14.8271 10.9342 14.231 12.1642 13.2358C12.1703 13.2423 12.1766 13.2488 12.183 13.2552L14.2053 15.2778C14.5015 15.5741 14.9817 15.5741 15.2779 15.2778C15.574 14.9816 15.574 14.5014 15.2779 14.2052L13.2555 12.1825C13.249 12.1761 13.2425 12.1698 13.2359 12.1636C14.2299 10.9337 14.8252 9.36816 14.8252 7.66355C14.8252 3.70723 11.6184 0.5 7.66261 0.5ZM2.01679 7.66355C2.01679 4.54504 4.54451 2.01699 7.66261 2.01699C10.7807 2.01699 13.3084 4.54504 13.3084 7.66355C13.3084 10.7821 10.7807 13.3101 7.66261 13.3101C4.54451 13.3101 2.01679 10.7821 2.01679 7.66355Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.84dce168b68cb3ca5ec26e61f5bdeb38.svg";
export { ForwardRef as ReactComponent };